import React from 'react';
import {
    Create, SimpleForm,
    TextInput, BooleanInput, ReferenceInput, AutocompleteInput,
} from 'react-admin';

import { required } from '../../util/fieldValidation';

import Districts from '../Districts';

import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles/showStyles';

const ClubsCreate = withStyles(styles)(({ permissions, classes,...props }) => (
    <Create {...props}>
        <SimpleForm submitOnEnter={false} >
            <TextInput
                source='ClubName'
                validate={[required()]}
            />
            {Districts.roles.includes(permissions) && <ReferenceInput
                source='DistrictID'
                validate={[required()]}
                reference='districts'
                sort={{ field: 'DistrictName', order: 'ASC' }}
                perPage={1000}
                filter={{ Active: true }}
                filterToQuery={searchText => ({ DistrictName_like: searchText })}
            >
                <AutocompleteInput optionText='DistrictName' />
            </ReferenceInput>}
            <ReferenceInput
                source='StateID'
                validate={[required()]}
                reference='states'
                sort={{ field: 'StateName', order: 'ASC' }}
                perPage={1000}
                filter={{ Active: true }}
                filterToQuery={searchText => ({ StateName_like: searchText })}
                formClassName={classes.inlineBlock}
            >
                <AutocompleteInput optionText='StateName' />
            </ReferenceInput>
            <ReferenceInput
                source='CountryID'
                validate={[required()]}
                reference='countries'
                sort={{ field: 'CountryName', order: 'ASC' }}
                perPage={1000}
                filter={{ Active: true }}
                filterToQuery={searchText => ({ CountryName_like: searchText })}
                formClassName={classes.inlineBlock}
            >
                <AutocompleteInput optionText='CountryName' />
            </ReferenceInput>
            <BooleanInput
                source='Active'
                defaultValue={true}
            />
        </SimpleForm>
    </Create>
));
export default ClubsCreate;